import React from 'react';
import './LoadingOverlay.scss';

const LoadingOverlay = () => (
    <div className="loading-overlay" />
);

export default LoadingOverlay;
